import { render, staticRenderFns } from "./SisterGallery.vue?vue&type=template&id=c546acc6&"
import script from "./SisterGallery.vue?vue&type=script&lang=js&"
export * from "./SisterGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports